export type AgentPageTab = 'tasks' | 'runs' | 'templates';

export function getAgentPageHref(tab: AgentPageTab): string {
  if (tab === 'runs') return '/app/agents/runs';
  if (tab === 'templates') return '/app/agents/templates';
  return '/app/agents';
}
